'use strict';

var teasersModules = require('../teaser/teasersModules');

module.exports = {
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail').not('.bundle-item').data('pid', response.data.product.id);
            }
            // Only run if client has variant products enabled
            if (useVariantsPreference) {
                TurnToCmd('set', { sku: response.data.product.id }); // eslint-disable-line new-cap
                teasersModules.loadTeaserCounts(response.data.product.id);
                TurnToCmd('gallery.set', { skus: [response.data.product.id] });// eslint-disable-line new-cap
            }
        });
    },
};
